import gql from "graphql-tag"

const techSpec = gql`
  fragment TechSpec on TechSpec {
    category
    id
    name
    subCategory
  }
`

export default techSpec
